import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "What is Real estate App Development?",
    answer: `<p>Real estate application development focuses on creating apps for property searches, buying, selling, renting, virtual tours, and facilitating communication among buyers, sellers, and agents. These applications simplify transactions and enhance overall client satisfaction.</p>`,
  },
  {
    question: "How much does it cost to develop a real estate app?",
    answer: ` <p>Generally, a basic app can cost between $25000 to $50000, whereas a more complex application may go beyond $80000 to $250,000.</p>
    <p>The cost of real estate app development depends on parameters such as the app’s functionality, the design of the interface, the technology that has been selected, and the country that hosts the development team.</p>`,
  },
  {
    question:
      "What process do you follow to develop a mobile app for the real estate industry?",
    answer: `<p>We follow a strategic approach to develop a Real Estate Mobile App. The steps include:</p>
    <ul>
    <li>Planning</li>
    <li>Market Research</li>
    <li>Design and Prototyping:</li>
    <li>Development</li>
    <li>Testing</li>
    <li>Deployment</li>
    <li>Maintenance and Support</li>
    </ul>`,
  },
  {
    question: "How long does it take to build a real estate application?",
    answer: `<p>On average, a simple app would take 4 to 6 months, whilst a complicated app would take at least 9 months or more.</p>`,
  },
  {
    question:
      "Why choose Tekrevol as your go-to real estate mobile application development company? ",
    answer: `<p>TekRevol stands out in real estate mobile application development for our customized solutions and expert team. We prioritize quality and timely delivery, ensuring your project achieves its goals effectively.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Real Estate App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
